import React from 'react';
import { Scrollbars as ReactCustomScrollbars } from 'react-custom-scrollbars-2';
import { Scrollbar as ReactScrollbarsCustom, type ScrollbarProps as Scrollbar2Props } from 'react-scrollbars-custom';

interface IProps {
    style?: React.CSSProperties;
    className?: string;
    id?: string;
    onScroll?: (e: React.UIEvent<Element>) => void;
    children?: React.ReactNode;
    autoHide?: boolean;
    autoHeight?: boolean;
    autoHeightMax?: number;
    autoHeightMin?: number;
    onScrollFrame?: () => {};
    onScrollStop?: () => {};
    scrollbarsRef?: React.MutableRefObject<ReactCustomScrollbars>;
}

const thumbStyle: React.CSSProperties = {
    backgroundColor: 'var(--background-system-scrollbar)',
    borderRadius: '4px',
};

// 兼容性贼差
const Scrollbars = (props: IProps) => {
    const {
        children,
        style,
        className,
        onScroll,
        autoHide = false,
        autoHeight = false,
        autoHeightMax,
        autoHeightMin,
        onScrollFrame,
        onScrollStop,
        id,
        scrollbarsRef,
    } = props;

    return (
        <ReactCustomScrollbars
            ref={scrollbarsRef}
            style={{ ...style }}
            className={className}
            renderThumbVertical={() => <div style={{ ...thumbStyle }} />}
            onScroll={onScroll}
            autoHide={autoHide}
            autoHeight={autoHeight}
            autoHeightMax={autoHeightMax}
            autoHeightMin={autoHeightMin}
            onScrollFrame={onScrollFrame}
            onScrollStop={onScrollStop}
            id={id}
        >
            {children}
        </ReactCustomScrollbars>
    );
};

/** look more: https://www.npmjs.com/package/react-scrollbars-custom#instance-properties */
export interface ScrollBars2Ref {
    /** (get|set) scrollTop */
    scrollTop: number;
    /** (get|set) scrollLeft */
    scrollLeft: number;
}

export const ScrollBars2 = React.forwardRef<ScrollBars2Ref, Scrollbar2Props>(
    ({ children, thumbXProps, thumbYProps, ...restProps }, ref) => {
        return (
            <ReactScrollbarsCustom
                ref={ref as any}
                thumbXProps={{ style: thumbStyle, ...thumbXProps }}
                thumbYProps={{ style: thumbStyle, ...thumbYProps }}
                {...restProps}
            >
                {children}
            </ReactScrollbarsCustom>
        );
    },
);

export default Scrollbars;
